import { Reveal } from "./Reveal";

export const SectionHeading = ({ eyebrow, title, subtitle, dark = false, align = "left" }) => (
    <Reveal className={align === "center" ? "text-center" : "text-left"}>
        <span
            className={`inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] ${
                dark ? "text-gold" : "text-gold-dark"
            }`}
        >
            <span className={`h-px w-8 ${dark ? "bg-gold/60" : "bg-gold"}`} aria-hidden="true" />
            {eyebrow}
        </span>
        <h2
            className={`mt-4 font-heading text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl ${
                dark ? "text-white" : "text-navy-900"
            }`}
        >
            {title}
        </h2>
        {subtitle && (
            <p
                className={`mt-4 max-w-2xl text-base leading-relaxed sm:text-lg ${
                    dark ? "text-slate-400" : "text-slate-600"
                } ${align === "center" ? "mx-auto" : ""}`}
            >
                {subtitle}
            </p>
        )}
    </Reveal>
);
